// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"assignment-code"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M9.70802 2.5C10.0938 1.61705 10.9748 1 12 1C13.0252 1 13.9062 1.61705 14.292 2.5H20.5V21.5H3.5V2.5H9.70802Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.70802 2.50001C10.0938 1.61706 10.9748 1.00001 12 1.00001C13.0252 1.00001 13.9062 1.61706 14.292 2.50001L20.5 2.50001L20.5 21.5L3.5 21.5L3.5 2.50001L9.70802 2.50001Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9.5 9.50001L7 12L9.5 14.5M14.5 14.5L17 12L14.5 9.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AssignmentCodeIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'assignment-code',
    ref,
    icon: element,
  },
));

AssignmentCodeIcon.displayName = 'AssignmentCodeIcon';

export default AssignmentCodeIcon;
